import React from 'react';
import PropTypes from 'prop-types';

import MaterialIcon from 'shared/react_components/MaterialIcon';

const errorStatuses = ['AccountSyncFailure', 'Failed', 'BrokenAuth', 'Danger'];
const warningStatuses = ['NoAccounts', 'NotConfigured', 'AccountSyncPending', 'Pending', 'PartialBrokenAuth', 'Warning'];
const successStatuses = ['Configured', 'Success', 'Complete'];

const iconTypeToClassName = {
  error: "text-danger",
  warning: "text-warning",
  success: "text-success"
};

function Icon({ type, ...props }) {
  const icon = type === "success" ? "check" : type;
  return <MaterialIcon name={icon} className={`icon--status ${iconTypeToClassName[type]}`} {...props}/>;
}

Icon.propTypes = {
  type: PropTypes.oneOf(["error", "warning", "success"])
};

function statusMessage(status, integrationName) {
  switch (status) {
  case "NoAccounts":
    return "Not yet synced";
  case "NotConfigured":
    return "Accounts have not been configured";
  case "AccountSyncPending":
  case "Pending":
    return "Account sync in progress";
  case "AccountSyncFailure":
  case "Failed":
    return "Account sync failed";
  case "PartialBrokenAuth":
  case "Warning":
    return "Data is not being sent to certain Accounts";
  case "BrokenAuth":
  case "Danger":
    return `Data is not being sent to ${integrationName}`;
  case "Configured":
  case "Success":
  case "Complete":
    return `Sending data to ${integrationName}`;
  }
}

const IntegrationStatus = ({ status, integrationName }) => {
  let iconType = "warning";

  if (errorStatuses.indexOf(status) >= 0) {
    iconType = "error";
  } else if (successStatuses.indexOf(status) >= 0) {
    iconType = "success";
  }

  return (
    <div data-attr='integration-status'>
      <Icon type={iconType} data-test-id='integration-status-icon'/>
      <p className='d-inline-block mr-small' data-test-id='integration-status-message'>{statusMessage(status, integrationName)}</p>
    </div>
  );
};

IntegrationStatus.propTypes = {
  status: PropTypes.oneOf(successStatuses.concat(warningStatuses, errorStatuses)).isRequired,
  integrationName: PropTypes.string.isRequired
};

export default IntegrationStatus;
